module.exports = __webpack_public_path__ + "img/gdb.6b804e4d.jpg";